import { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './ProductFundraisingProgress.module.scss';
import { formatter } from '../utility';
import classNames from 'classnames';

let timerID;

const ProductFundraisingProgress = ({
  radius,
  percentage,
  lineColor,
  circleColor,
  darkMode
}) => {
  const PADDING = 4; // padding from svg to path(circle)
  const strokeWidth = PADDING / 2;
  const svgSize = radius * 2 + PADDING;
  const circleCenter = radius + PADDING / 2;

  useEffect(() => {
    const path = document.getElementById('path');
    const circle = document.getElementById('circle');
    const number = document.getElementById('number');
    if (path && circle && number) {
      path.setAttribute(
        'transform',
        `translate(${circleCenter},${circleCenter})`
      );
      let currentPercentage = 0;
      const setPercentage = () => {
        const degree = (currentPercentage / 100) * 360;
        const largeArcFlag = window.Number(degree > 180);
        const x = radius * Math.sin(degree * (Math.PI / 180));
        const y = radius * Math.cos(degree * (Math.PI / 180));
        path.setAttribute(
          'd',
          `M 0 ${-radius} A ${radius},${radius} 0 ${largeArcFlag} 1 ${x} ${-y}`
        );

        number.textContent = `${formatter(
          Math.round(percentage > 100 ? percentage : currentPercentage)
        )}`;
        currentPercentage += 1;

        if (degree >= 360) {
          circle.setAttribute('stroke', lineColor);
          path.style.display = 'none';
          return cancelAnimationFrame(timerID);
        }

        if (currentPercentage <= percentage) {
          timerID = requestAnimationFrame(setPercentage);
        }

        return undefined;
      };

      timerID = requestAnimationFrame(setPercentage);
    }
  }, [circleCenter, lineColor, percentage, radius]);

  return (
    <Fragment>
      <div className={styles.productFundraisingProgress}>
        <svg width={svgSize} height={svgSize}>
          <circle
            id="circle"
            cx={circleCenter}
            cy={circleCenter}
            r={radius}
            stroke={circleColor}
            strokeWidth={strokeWidth}
            fill="none"
          />
          <path
            id="path"
            stroke={lineColor}
            strokeWidth={strokeWidth}
            fill="none"
          />
        </svg>
        <div
          className={`${styles.productFundraisingProgressDetail} ${
            percentage >= 10000
              ? styles.productFundraisingProgressDetailMore
              : ''
          }`}
        >
          <span
            className={classNames(
              styles.productFundraisingProgressDetailNumber,
              {
                'dark-mode gray2-bgc': darkMode
              }
            )}
            id="number"
          >
            0
          </span>
          <span
            className={classNames(styles.productFundraisingProgressDetailUnit, {
              'dark-mode gray2-bgc': darkMode
            })}
          >
            %
          </span>
        </div>
      </div>
    </Fragment>
  );
};

ProductFundraisingProgress.propTypes = {
  radius: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  lineColor: PropTypes.string.isRequired,
  circleColor: PropTypes.string.isRequired
};

export default ProductFundraisingProgress;
